// Componentes internos
import API from "../helpers/API"

/**
 * Componente funcional para manipulacão dos dados dos usuários
 */
const ProductController = {
  fetchOne(uuid_product, options = {}) {
    const { signal } = options
    return API.request("/v1/product/" + uuid_product, [], "GET", {}, 30000, 3, signal)
  },

  fetchSizes(uuid_product, options = {}) {
    const { signal } = options

    return API.request("/v1/product/" + uuid_product + "/sizes", [], "GET", {}, 30000, 3, signal)
  },

  fetchFlavoursBySize(data) {
    const { uuid_product } = data
    return API.request("/v1/product/" + uuid_product + "/flavours/website", data, "GET")
  },
  fetchFlavours({ uuid_product, withSizes = false, withIngredients = false }, options = {}) {
    const { signal } = options

    return API.request("/v1/product/" + uuid_product + "/flavours", { withSizes, withIngredients, stWebsite: true }, "GET", {}, 30000, 3, signal)
  },

  fetchOneFlavour(params) {
    return API.request("/v1/flavour/one/", params, "GET")
  },

  fetchComplements(uuid_product) {
    return API.request("/v1/product/" + uuid_product + "/complements", { withSizes: true, withAdditionals: true }, "GET")
  },

  fetchAdditionals(uuid_product) {
    return API.request("/v1/product/" + uuid_product + "/additionals", [], "GET")
  },

  fetchIngredients(uuid_product) {
    return API.request("/v1/product/" + uuid_product + "/ingredients", [], "GET")
  },

  fetchIngredientsMemory(productUid, filter = {}, options = {}) {
    const { signal } = options
    let headers = {}
    if (!!filter.companyUid) {
      headers = { Company: filter.companyUid }
    }
    return API.request("/v1/product/" + productUid + "/ingredients/memory", [], "GET", headers, 30000, 3, signal)
  },

  fetchIngredientsInitial(productUid, filter = {}, options = {}) {
    const { signal } = options
    let headers = {}
    if (!!filter.companyUid) {
      headers = { Company: filter.companyUid }
    }
    return API.request("/v1/product/" + productUid + "/ingredients/initial", filter, "GET", headers, 30000, 3, signal)
  },

  fetchAll(filter = {}) {
    const params = {
      orderField: "id",
      orderKeyword: "asc",
      page: 1,
      pageSize: 1000,
      stWebsite: true,
      withCompany: true,
      ...filter,
    }

    return API.request("/v1/product", params, "GET")
  },

  fetchAllMemory() {
    return API.request("/v1/product/memory/all", [], "GET")
  },

  fetchAllOrder() {
    const params = {
      order: [
        {
          field: "id_product",
          keyword: "ASC",
        },
      ],
      where: { st_status: "1" },
      pagination: {
        page: 1,
        pageSize: 100,
      },
    }

    return API.request("/v1/product", params, "GET")
  },
}

export default ProductController
